import React from 'react';
import { useI18n } from '../i18n';
import './LegalDocs.css';

const privacyCopy = {
  es: {
    title: 'POL\u00cdTICA DE PRIVACIDAD GLOBAL DE QPROJECT',
    updated: '\u00daltima actualizaci\u00f3n: 22 de Febrero de 2026',
    sections: [
      {
        title: '1. RESPONSABLE DEL TRATAMIENTO',
        body: ['Qproject, con sede y jurisdicci\u00f3n principal en la Rep\u00fablica Argentina, es el Responsable del Tratamiento de los datos personales recogidos a trav\u00e9s de la aplicaci\u00f3n.']
      },
      {
        title: '2. DATOS QUE RECOPILAMOS',
        body: ['Dada la naturaleza introspectiva y anal\u00edtica de Qproject, recopilamos los siguientes niveles de datos:'],
        bullets: [
          'Datos de Cuenta y Perfil: nombre, correo electr\u00f3nico e identificadores OAuth.',
          'Datos de Uso y Navegaci\u00f3n: patrones de interacci\u00f3n, intenciones de navegaci\u00f3n detectadas por texto o voz y metadatos de uso.',
          'Datos Sensibles: voz, transcripciones, comandos, perfiles psicol\u00f3gicos y respuestas reflexivas usadas para personalizar la experiencia.'
        ]
      },
      {
        title: '3. FINALIDAD DEL TRATAMIENTO',
        body: ['Tus datos se utilizan exclusivamente para proveer Qproject, crear un perfil conductual y emocional din\u00e1mico, entrenar tu extensi\u00f3n digital personal y proteger tu cuenta mediante autenticaci\u00f3n multifactor.']
      },
      {
        title: '4. SUB-PROCESADORES Y TRANSFERENCIA INTERNACIONAL',
        body: ['Para brindar capacidades avanzadas de IA, Qproject puede compartir fragmentos de textos, transcripciones y perfiles anonimizados con proveedores externos como Google Gemini o modelos locales/cloud. Qproject aplica l\u00edmites de caracteres y sanitizaci\u00f3n antes de enviar datos a LLMs de terceros.']
      },
      {
        title: '5. RETENCI\u00d3N Y SEGURIDAD DE LOS DATOS',
        bullets: [
          'Datos sensibles como contrase\u00f1as y OTPs se almacenan con algoritmos criptogr\u00e1ficos.',
          'Los historiales de conciencia y perfiles psicol\u00f3gicos se conservan mientras tu cuenta est\u00e9 activa. Si eliminas tu cuenta, los registros asociados se purgan en un plazo m\u00e1ximo de 30 d\u00edas.'
        ]
      },
      {
        title: '6. TUS DERECHOS',
        body: ['Como usuario, puedes acceder, rectificar, exportar u oponerte al procesamiento automatizado de tus datos, y solicitar la eliminaci\u00f3n irreversible de tu cuenta y dataset personal.']
      }
    ],
    contact: 'Para ejercer estos derechos, env\u00eda una solicitud detallada a:'
  },
  en: {
    title: 'QPROJECT GLOBAL PRIVACY POLICY',
    updated: 'Last updated: February 22, 2026',
    sections: [
      {
        title: '1. DATA CONTROLLER',
        body: ['Qproject, headquartered and primarily governed by the jurisdiction of the Argentine Republic, is the Data Controller for personal data collected through the application.']
      },
      {
        title: '2. DATA WE COLLECT',
        body: ['Given Qproject introspective and analytical nature, we collect the following data layers:'],
        bullets: [
          'Account and Profile Data: name, email and OAuth identifiers.',
          'Usage and Navigation Data: interaction patterns, navigation intent detected through text or voice, and system-use metadata.',
          'Sensitive Data: voice, transcripts, commands, psychological profiles and reflective answers used to personalize the experience.'
        ]
      },
      {
        title: '3. PURPOSE OF PROCESSING',
        body: ['Your data is used exclusively to operate Qproject, build a dynamic behavioral and emotional profile, train your personal digital extension and protect your account through multifactor authentication.']
      },
      {
        title: '4. SUB-PROCESSORS AND INTERNATIONAL TRANSFERS',
        body: ['To provide advanced AI capabilities, Qproject may share fragments of text, transcripts and anonymized profiles with external providers such as Google Gemini or local/cloud models. Qproject applies character limits and sanitization before sending data to third-party LLMs.']
      },
      {
        title: '5. DATA RETENTION AND SECURITY',
        bullets: [
          'Sensitive data such as passwords and OTPs is stored using cryptographic algorithms.',
          'Consciousness histories and psychological profiles are retained while your account is active. If you delete your account, associated records are purged within a maximum of 30 days.'
        ]
      },
      {
        title: '6. YOUR RIGHTS',
        body: ['As a user, you may access, rectify, export or object to automated processing of your data, and request irreversible deletion of your account and personal dataset.']
      }
    ],
    contact: 'To exercise these rights, send a detailed request to:'
  }
};

const Privacy = () => {
  const { language } = useI18n();
  const copy = privacyCopy[language] || privacyCopy.es;

  return (
    <div className="legal-docs-container">
      <div className="legal-docs-content">
        <h1>{copy.title}</h1>
        <span className="legal-update-date">{copy.updated}</span>

        {copy.sections.map((section) => (
          <section key={section.title}>
            <h2>{section.title}</h2>
            {section.body?.map((paragraph) => <p key={paragraph}>{paragraph}</p>)}
            {section.bullets && (
              <ul>
                {section.bullets.map((item) => <li key={item}>{item}</li>)}
              </ul>
            )}
          </section>
        ))}

        <p>{copy.contact} <a href="mailto:quiddit.contact@gmail.com" style={{ color: 'var(--accent-color)' }}>quiddit.contact@gmail.com</a></p>
      </div>
    </div>
  );
};

export default Privacy;
